import { staticFileMap } from '/utils/static-file';
import { productCodeMap } from '@/utils/document/product-code-map';

const path = '/img/products/big-screen';
const docConfig = { name: '产品文档', link: productCodeMap.BIG_SCREEN };
export const BANNER_DATA = {
  title: '智能大屏',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/banner-mobile.webp`,
  description:
    '智能大屏是依托快手前沿的AI算法和特效技术，结合丰富的特效玩法，实现可靠、低延时、一站式的互动解决方案，可广泛应用于大型展会、商场、主题公园等线下场景品牌宣传和实景营销，助力合作者显著提升线下场景的互动消费体验',
  buttonText: '申请试用',
  buttonLink: '',
  mobileExtraButton: { ...docConfig },
  links: [
    // { name: 'Demo体验', link: '' },
    { ...docConfig },
    // { name: '管理控制台', link: '' },
  ],
};
export const ADVANTAGES_EFFECT = [
  {
    title: '丰富玩法库',
    content:
      '提供优质丰富的魔法表情资源，支持根据品牌文化、展会主题定制魔法表情',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '高精度自研算法加持',
    content:
      '自研高精度人脸/人体关键点检测、手势识别、分割等业界领先算法，可实现精准识别处理，效果自然、稳定、贴合度高，同时依托好莱坞级品质视觉效果的高性能渲染引擎，实现高品质、高真实渲染',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '一体化闭环解决方案',
    content:
      '提供从硬件采集到终端展示完整闭环的解决方案，助力客户快速拥有实时互动装置',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '灵活的方案配置',
    content:
      '根据需求自由选择照片打印、视频下载功能，并提供魔法表情、软件页面UI个性化定制',
    picUrl: `${path}/icon4.webp`,
  },
];

export const FEATURES = [
  {
    title: '丰富的特效玩法',
    content:
      '提供优质多样的魔法表情，实现高清美颜、3D特效、AR/MR魔法特效及互动游戏等效果',
    picUrl: `${path}/3D-icon1.webp`,
  },
  {
    title: '照片打印与视频下载',
    content:
      '支持线下活动打印照片与拍摄视频，根据不同场景灵活限定打印次数，下载并保存视频，可分享至社交平台',
    picUrl: `${path}/3D-icon2.webp`,
  },
  {
    title: '定制页面UI',
    content:
      '提供可灵活更换的视觉物料服务，包括客户端UI界面logo替换、活动页视觉物料替换、H5页面物料替换、活动链接分享文案以及推送文案自定义、打印纸相框自定义等',
    picUrl: `${path}/3D-icon3.webp`,
  },
  {
    title: '提供数据监测 ',
    content:
      '智能大屏提供数据埋点功能，方便业务侧直观看到活动中互动屏的数据表现情况，帮助业务侧更好地查看活动收益和成效',
    picUrl: `${path}/3D-icon4.webp`,
  },
];

export const SCENARIO_EFFECT = [
  {
    title: '展会获客',
    content:
      '智能大屏是展会的引流利器，可根据客户产品与活动主题策划定制您的专属互动屏，以吸引观众参观展位，并拉新转化为线上流量',
    picUrl: `${path}/scenario1.webp`,
    picHoverUrl: `${path}/scenario1-hover.webp`,
  },
  {
    title: '品牌营销',
    content:
      '针对品牌周年庆、节日促销等营销热点，智能大屏可提供新颖的现场互动连接消费者和品牌，方便品牌的线下体验，引导关注，线上营销',
    picUrl: `${path}/scenario2.webp`,
    picHoverUrl: `${path}/scenario2-hover.webp`,
  },
  {
    title: '线下引流',
    content:
      '商场、餐厅等场所，通过趣味游戏、体感互动等技术手段“抓住”路过客户的眼球，聚集人气、活跃气氛',
    picUrl: `${path}/scenario3.webp`,
    picHoverUrl: `${path}/scenario3-hover.webp`,
  },
];

export const DEMO_LIST = [
  {
    title: '切换特效',
    subTitle: '通过手势比“6”，可以进行特效玩法的切换',
    videoUrl: staticFileMap['big-screen-demo1'],
    backgroundImg: `${path}/big-screen-bg1.webp`,
    placeholder: `${path}/demo1-placeholder.webp`,
  },

  {
    title: '保存图片',
    subTitle: '通过手势比“大拇指”进行截屏，并按相关提示打印照片',
    videoUrl: staticFileMap['big-screen-demo2'],
    backgroundImg: `${path}/big-screen-bg2.webp`,
    placeholder: `${path}/demo2-placeholder.webp`,
  },
  {
    title: '下载视频',
    subTitle: '通过手势比“ok”扫码拍摄视频，并按相关提示下载保存视频',
    videoUrl: staticFileMap['big-screen-demo3'],
    backgroundImg: `${path}/big-screen-bg3.webp`,
    placeholder: `${path}/demo3-placeholder.webp`,
  },
];

export const ARCHITECTURE = {
  title: '产品架构',
  picUrl: `${path}/architecture.webp`,
};

export const BRAND = {
  title: '客户案例',
  items: ['快手', 'AcFun'],
};

export const GALLERY = {
  title: '活动现场',
  spirit: `${path}/activity.webp`,
  pics: Array.from({ length: 6 }, (_, i) => `${path}/gallery${i + 1}.webp`),
};
